import { IVault, ProgressBar } from '.'
import styled, { keyframes } from 'styled-components'
import { Box } from '../../../shared_components/UI/Box'
import TickUpNumber from '../../../shared_components/TickUpNumber'
import { Tooltip } from 'react-tooltip'

const TokensEarned = ({ vault }: { vault: IVault }) => {
  const { tokensEarned } = vault
  const { standard, bonus, total, totalWeighting } = tokensEarned

  const bonusProportion = (bonus / total) * 100
  const standardProportion = (standard / total) * 100

  return (
    <Container dc g={16} ac alignSelf="flex-end">
      <Box afe jsb fu>
        <Box afe g={8}>
          <span className="label">TOTAL</span>
          <span className="amount">
            <TickUpNumber amount={toInt(total)} />
          </span>
        </Box>
        <Box ac jfe g={8}>
          <Box afe g={8} jfe columnMobile>
            <span className="label label-right">
              Your bonus pool amplifier{' '}
            </span>
            <div className="blur-container">
              {!!totalWeighting && (
                <span className="amount blur">{toInt(totalWeighting)}x</span>
              )}
              <span className="amount">
                <TickUpNumber amount={toInt(totalWeighting)} />x
              </span>
            </div>
          </Box>
          <Box fu aw alignSelf="flex-end" padding="0 0 4px 0">
            <img
              src="/img/icons/info-circle.svg"
              style={{ marginRight: 8 }}
              alt="info tooltip icon"
              data-tooltip-id="bonus-amplifier-info"
            />
            <Tooltip
              id="bonus-amplifier-info"
              place="bottom-start"
              opacity={1}
              style={{
                marginRight: '8px',
                scale: 0.5,
                maxWidth: '310px',
                zIndex: 10,
              }}
            >
              <span>
                Your multiplier is a combination of your vaults and your
                referrals. Please note multipliers are updated at the end of
                each 24 hour period.
              </span>
            </Tooltip>
          </Box>
        </Box>
      </Box>
      <Box fu>
        <ProgressBar
          progress={standardProportion}
          secondProgress={bonusProportion}
        />
      </Box>
      <Box ac jsb fu>
        <Box ac g={8}>
          <span className="label yellow">regular pool</span>
          <span className="amount small yellow">
            <TickUpNumber amount={toInt(standard)} />
          </span>
        </Box>
        <Box ac g={8} jfe>
          <span className="label">bonus pool</span>
          <span className="amount small">
            <TickUpNumber amount={toInt(bonus)} />
          </span>
        </Box>
      </Box>
      <Box fu>
        <span className="disclaimer">
          Rewards are delivered daily to all Vaults. The more Vaults you hold,
          the higher your rewards.
        </span>
      </Box>
    </Container>
  )
}

function toInt(num: number) {
  // running floor for now
  return Math.floor(num)
}

export default TokensEarned

const blurAnimation = keyframes`
  from {
    opacity: 0.75;
    filter: blur(14px);
  }
  to {
    opacity: 1;
    filter: blur(18px);
  }
`

const Container = styled(Box)`
  width: 100%;
  height: 182px;
  padding-top: 0.5rem;
  span.label {
    opacity: 0.65;
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 150%; /* 16px */
    letter-spacing: -0.16px;
    text-transform: uppercase;
  }
  span.amount {
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 16px */
    text-transform: uppercase;
  }
  span.small {
    font-size: 16px;
  }
  .blur-container {
    position: relative;
  }
  .blur {
    position: absolute;
    top: 0;
    left: 0;
    transform: scale(1);
    animation: ${blurAnimation} 2.5s infinite alternate;
  }
  span.disclaimer {
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0.36px;
    opacity: 0.6;
  }

  @media screen and (max-width: 1000px) {
    span.label.label-right {
      text-align: right;
      margin-right: -32px;
    }
  }
`
